// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidateState } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

export const xValidateState: typeof ValidateState = props => {
    const { country, state } = props.parameter.address;
    // xng-change
    const { addressFieldDisplayCollection, validationRules } = props.parameter;
    const countries = getCurrentCountries(props.getState());
    if (!countries) {
        throw new Error("Cannot validate country. The website countries have not been loaded yet.");
    }

    if (!country) {
        // This is fine to simply return because the address country
        // is validated in the previous handler. If the country has not
        // been selected yet, it doesn"t make sense to show an error for the state.
        return;
    }

    const countryLookup = countries.find(c => c.id === country.id);
    if (
        countries.length > 0 &&
        countryLookup?.states &&
        countryLookup.states.length > 0 &&
        // xng-change
        validationRules.state?.isRequired &&
        !state &&
        addressFieldDisplayCollection.state
    ) {
        props.addressErrors.state = getRequiredErrorMessage(addressFieldDisplayCollection.state);
    }
};

replaceInChain(chain, ValidateState, xValidateState);
